import type { ComponentChildren } from 'preact';

export type Tone = 'ok' | 'warn' | 'err' | 'info' | 'muted' | 'outline';

export function Badge({ tone = 'muted', title, children }: { tone?: Tone; title?: string; children: ComponentChildren }) {
  return (
    <span class={`badge badge-${tone}`} title={title}>
      {children}
    </span>
  );
}
